module.exports = __webpack_public_path__ + "img/sb.5bc69a36.svg";